import React, { FC } from "react";
import { ChannelHintPicker } from "./ChannelHintPicker";
import {
  ComposerSendIndicatorState,
  ComposerSendStatusIndicator,
} from "./ComposerSendStatusIndicator";
import { ChannelHint } from "@/types/chat-external-message";
import {
  ExternalCommunicationChannelKind,
  MessagingChannelConfig,
} from "@/types/messaging-channel-config";

interface MultiChannelComposerSlotProps {
  show: boolean;
  selected: ChannelHint;
  onSelect: (next: ChannelHint) => void;
  configs: MessagingChannelConfig[];
  unavailableChannels: ReadonlySet<ExternalCommunicationChannelKind>;
  disabled: boolean;
}

export const MultiChannelPickerSlot: FC<MultiChannelComposerSlotProps> = ({
  show,
  selected,
  onSelect,
  configs,
  unavailableChannels,
  disabled,
}) => {
  if (!show) return null;
  return (
    <ChannelHintPicker
      selected={selected}
      onSelect={onSelect}
      configs={configs}
      unavailableChannels={unavailableChannels}
      disabled={disabled}
    />
  );
};

interface MultiChannelIndicatorSlotProps {
  show: boolean;
  state: ComposerSendIndicatorState;
}

export const MultiChannelIndicatorSlot: FC<MultiChannelIndicatorSlotProps> = ({
  show,
  state,
}) => {
  if (!show) return null;
  return (
    <div className="px-3 pb-2">
      <ComposerSendStatusIndicator state={state} />
    </div>
  );
};
